export default __webpack_public_path__ + "static/media/quality.d87cc0cb.svg";